import ActivateCard from '../../../../banking/components/cards/ActivateCard';

const ActivateCardScreen = () => {
    return <ActivateCard />;
};

export default ActivateCardScreen;
